/**
 * Rounds a numeric value to the specified number of decimal places.
 */
const round = (value: number, decimals: number): number => {
  const factor = Math.pow(10, decimals)
  return Math.round(value * factor) / factor
}

/**
 * Calculates the monetary refund amount for a cancelled booking.
 * The refund is the original payment amount minus Stripe processing fees.
 */
export const calculateRefundAmount = (transaction: {
  amount: number
  stripeFee: number
}): number => {
  return round(transaction.amount - transaction.stripeFee, 2)
}

/**
 * Determines the dive status after a participant cancellation.
 * A dive that was "full" becomes "open" (freed spot), and "open" stays "open".
 * Any other status is returned unchanged (should not occur due to eligibility checks).
 */
export const getDiveStatusAfterCancellation = (
  currentDiveStatus: string
): string => {
  if (currentDiveStatus === 'full' || currentDiveStatus === 'open') {
    return 'open'
  }
  return currentDiveStatus
}
